module.exports = {
	"description": "Cards are used to group conceptually related content.\nCards represent a gateway to more detailed information in another app view.\nYou can use Cards to provide detail about a feature in your app, or to represent data with which your users can interact.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": true,
			"description": "Content of the Card. Can be anything, but see [CardBlock](../card-block), [CardImage](../card-image), and [CardTitle](../card-title)."
		},
		"onClick": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called with the click event"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Card/Card.js
// module id = 1600
// module chunks = 0